import Layout from 'components/Layout';
import UserProfile from 'components/UserProfile';
import Dashboard from 'components/home/Dashboard';
import System from 'components/system';
import MRF from 'mrf/MRF';
import useScrollToTop from 'mrf/utils/useScrollToTop';
import ChangePassword from 'mrf/view/ChangePassword';
import Authenticate from 'mrf/view/user/Authenticate';
import RouteAuth from 'mrf/view/user/RouteAuth';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { Switch } from 'react-router';
import role from 'role';
import { Spinner, SpinnerWrapper } from 'styles/components/Spinner';
import SystemInfo from './mrf/view/SystemInfo';
import Reports from 'components/reports';

export const apiPrefix = '';

export default function App() {
    const spinner = useSelector(state => state?.resources?.spinner) && ReactDOM.createPortal(
        <>
            <SpinnerWrapper aria-hidden>
                <Spinner />
            </SpinnerWrapper>
        </>, document.body
    );

    useScrollToTop();

    return <MRF>
        {spinner}
        <Authenticate>
            <Layout navLinks={navLinks}>
                <Switch>
                    { navLinks.map((link, i) =>
                        <RouteAuth key={i} path={link.path} component={link.component} roleCodes={link.roleCodes} />
                    )}
                    <RouteAuth exact path='/' component={Dashboard} />
                    <RouteAuth path='/profile' component={UserProfile} />
                    <RouteAuth path='/help' component={SystemInfo} />
                    <RouteAuth path='/changePassword' component={ChangePassword} />
                </Switch>
            </Layout>
        </Authenticate>
    </MRF>
}

const navLinks = [
    {
        name: 'Home',
        path: '/home',
        icon: '',
        component: Dashboard,
        roleCodes: [] // checks if the user is logged in
    },
    {
        name: 'Reports',
        path: '/reports',
        icon: '',
        component: Reports,
        roleCodes: [role.ADMIN],
    },
    {
        name: 'System',
        path: '/system',
        icon: '',
        component: System,
        roleCodes: [role.ADMIN],
    },
];
